import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Select from 'react-select';

import Const from '../../../util/Constants';
import ReportConst from '../../../util/ReportConst';

class DashboardPopup extends React.Component {

  constructor(props) {
    super(props);
    this.state = { id: 0, name: '', reports: [] };
    this.Types = [{ value: ReportConst.Report, label: 'Reports'}, 
    { value: ReportConst.DashLead, label: 'Widgets' }]
  }

  UNSAFE_componentWillReceiveProps(props) {
    let dashboard = props.dashboard;
    if(!dashboard) {
      dashboard = { id: 0, name: '', type: 0, reports: [], dashleads: [] };
    }

    const reports = props.reports ? props.reports.filter(opt => 
      dashboard.reports && dashboard.reports.includes(`${Const.Opt}${opt.value}${Const.Opt}`)) : [];
    const dashleads = props.dashleads ? props.dashleads.filter(opt => 
      dashboard.dashleads && dashboard.dashleads.includes(`${Const.Opt}${opt.value}${Const.Opt}`)) : [];

    this.setState({ id: dashboard.id, name: dashboard.name, type: dashboard.type, reports, dashleads });
  }

  onChange = val => this.setState({ ...this.state, name: val });
  onReportChange = val => this.setState({ ...this.state, reports: val });
  onDashleadChange = val => this.setState({ ...this.state, dashleads: val });
  onTypeChange = item => this.setState({ ...this.state, type: item.value });

  save = () => {
    const dashbaord = { ...this.state };
    dashbaord.reports = dashbaord.reports.map(report => report.value);
    dashbaord.reports = Const.Opt + dashbaord.reports.join(Const.Opt) + Const.Opt;
    dashbaord.dashleads = dashbaord.dashleads.map(dashlead => dashlead.value);
    dashbaord.dashleads = Const.Opt + dashbaord.dashleads.join(Const.Opt) + Const.Opt;
    this.props.save(dashbaord);
  }

  render() {
    return (
      <Modal show={this.props.popup} onHide={this.props.onHide} 
        size="md" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Dashboard</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="row-cols-2 colmr">
              <Col xs={12}>
                <Form.Label>Name</Form.Label>
                <Form.Control type="text" placeholder="Name" className="mr-sm-2"
                  value={this.state.name} onChange={event => this.onChange(event.target.value)} />
              </Col>
              <Col xs={12}>
                <Form.Label>Type</Form.Label>
                <Select value={this.Types.find(item => item.value === this.state.type)}
                  onChange={this.onTypeChange} isMulti={false}
                  options={this.Types} isSearchable={true} isClearable={false} />
              </Col>

              { this.state.type === ReportConst.Report
                ? <Col xs={12}>
                  <Form.Label>Reports</Form.Label>
                  <Select value={this.state.reports} onChange={this.onReportChange} isMulti={true}
                    options={this.props.reports} isSearchable={true} isClearable={true} />
                </Col> : null
              }

              { this.state.type === ReportConst.DashLead
                ? <Col xs={12}>
                  <Form.Label>DashLeads</Form.Label>
                  <Select value={this.state.dashleads} onChange={this.onDashleadChange} isMulti={true}
                    options={this.props.dashleads} isSearchable={true} isClearable={true} />
                </Col> : null
              }
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.save}>Save</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default DashboardPopup;